import { render, staticRenderFns } from "./BatteryDetail.vue?vue&type=template&id=4606f7a2&"
import script from "./BatteryDetail.vue?vue&type=script&lang=js&"
export * from "./BatteryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports